import React from "react";
import Icon from "./Icon";
import {SocialLink as SocialLinkType} from "../data/portfolio";
import Magnet from "@/components/Magnet.tsx";

interface SocialLinkProps {
    socialLink: SocialLinkType;
}

const SocialLink: React.FC<SocialLinkProps> = ({socialLink}) => {
    return (
        <a
            href={socialLink.href}
            target="_blank"
            rel="noopener noreferrer"
            aria-label={socialLink.ariaLabel}
            title={socialLink.title}
            className={`text-4xl hover:scale-110 transition-transform ${socialLink.hoverColor || ''}`}
        >
            <Magnet padding={120} disabled={socialLink.icon === 'github'} magnetStrength={1} innerClassName={'cursor-target'}>
                <Icon icon={socialLink.icon}/>
            </Magnet>
        </a>
    );
};

export default SocialLink;
